import SevLayout from '@/layouts/sev'

export default [
  {
    name: 'sev',
    path: '/',
    redirect: '/home',
    component: SevLayout,
    children: [
      {
        name: 'home',
        path: '/home',
        component: () => import('_sev/home'),
        meta: {
          title: '售后服务'
        }
      },
      {
        name: 'select',
        path: '/select/:path',
        component: () => import('_sev/home/Select'),
        meta: {
          title: '新增售后服务'
        }
      },
      {
        name: 'selectOrder',
        path: '/selectOrder/:path',
        component: () => import('_sev/home/SelectOrder'),
        meta: {
          title: '选择订单商品'
        }
      },
      {
        name: 'Address',
        path: '/address',
        component: () => import('_sev/address'),
        meta: {
          title: '选择地址'
        }
      },
      {
        name: 'AddAddress',
        path: '/address/add',
        component: () => import('_sev/address/Edit'),
        meta: {
          title: '新增地址'
        }
      },
      {
        name: 'EditAddress',
        path: '/address/edit/:id',
        component: () => import('_sev/address/Edit'),
        meta: {
          title: '编辑地址'
        }
      },
      {
        name: 'install',
        path: '/install',
        component: () => import('_sev/home/EditService'),
        meta: {
          title: '安装服务',
          type: 2
        }
      },
      {
        name: 'maintain',
        path: '/maintain',
        component: () => import('_sev/home/EditService'),
        meta: {
          title: '维修服务',
          type: 1
        }
      },
      {
        name: 'dismantle',
        path: '/dismantle',
        component: () => import('_sev/home/EditService'),
        meta: {
          title: '拆机服务',
          type: 3
        }
      },
      {
        name: 'move',
        path: '/move',
        component: () => import('_sev/home/EditService'),
        meta: {
          title: '移机服务',
          type: 4
        }
      },
      {
        name: 'schedule',
        path: '/schedule',
        component: () => import('_sev/schedule'),
        meta: {
          title: '我的服务单'
        }
      },
      {
        name: 'scheduleDetail',
        path: '/schedule/detail/:id',
        component: () => import('_sev/schedule/Detail'),
        meta: {
          title: '服务详情'
        }
      },
      {
        name: 'scheduleEvaluation',
        path: '/schedule/evaluation/:serviceTicketId/:receiptId?',
        component: () => import('_sev/schedule/Evaluation'),
        meta: {
          title: '评价'
        }
      },
      {
        name: 'rates',
        path: '/rates',
        component: () => import('_sev/rates'),
        meta: {
          title: '收费标准'
        }
      },
      {
        name: 'ratesDetail',
        path: '/rates/detail/:type',
        component: () => import('_sev/rates/Detail'),
        meta: {
          title: '费用明细'
        }
      }
    ]
  },
  {
    name: 'severror',
    path: '*',
    component: SevLayout,
    children: [
      {
        path: '*',
        name: 'errorpage',
        component: () => import('@/views/404'),
        props: route => route.query,
        meta: {
          title: '错误页面'
        }
      }
    ]
  }
]
